/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_OnlineInputs */



/**
* | output |
* | --- |
* | "Online Tournament" |
*
* @param {Tfield_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_online = /** @type {((inputs?: Tfield_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournoi en ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneo en línea")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio Online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torneo Online")
	return /** @type {LocalizedString} */ ("Online Tournament")
});